import {
  CircularProgress,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core"
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle"
import classnames from "clsx"
import PropTypes from "prop-types"
import { useContext, useState } from "react"
import { useMutation, useQueryClient } from "react-query"
import { Link } from "react-router-dom"
import { setCourseLab } from "~/actions/courses"
import LabIcon from "~/assets/Icons/lab-icon.svg"
import HoverText from "~/components/Common/HoverText"
import PaperListRow from "~/components/Common/PaperListRow"
import AppContext from "~/contexts/App"
import useOpenErrorSnackbar from "~/hooks/useOpenErrorSnackbar"

import Box from "~/components/Common/Box"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import useStyles from "./styles"

const AddedLab = ({ courseId, lab, disabled }) => {
  const classes = useStyles()

  const { openDialog } = useContext(AppContext)

  const [deleting, setDeleting] = useState(false)

  const queryClient = useQueryClient()
  const openErrorSnackbar = useOpenErrorSnackbar()

  const setCourseLabMutation = useMutation("setCourseLab", (mutationData) =>
    setCourseLab(...mutationData),
  )

  const handleRemoveLab = () => {
    openDialog("confirmDialog").then(() => {
      setDeleting(true)
      setCourseLabMutation.mutate([courseId, { lab_id: null }], {
        onSuccess: (res) => {
          queryClient.setQueryData(["course", courseId], () => {
            return res
          })
        },
        onError: (err) => {
          openErrorSnackbar(err, "Error Removing Lab")
          console.error(err)
        },
      })
    })
  }

  return (
    <PaperListRow componentWidth={"100%"}>
      <Grid
        container
        spacing={0}
        className={classnames(classes.container, {
          [classes.disabled]: deleting,
        })}
      >
        {deleting && (
          <Box className={classes.spinnerBox}>
            <CircularProgress size={20} />
          </Box>
        )}
        <Grid
          item
          md={4}
          xs={12}
          className={classes.titleContainer}
          style={disabled ? { filter: "opacity(0.5)" } : null}
        >
          <Link to={`/labs/${lab.id}`}>
            <Box display="flex" alignItems="center">
              <img
                src={LabIcon}
                alt="Lab"
                style={{ width: 18, marginRight: 16 }}
              />
              <HoverText
                data={lab?.name}
                size={30}
                variant="h3"
                className={classes.nameText}
              />
            </Box>
          </Link>
        </Grid>
        <Grid item md={3} xs={12}>
          {lab?.instances?.length > 0 && (
            <Typography variant="h4">
              Servers: {lab.instances.length}
            </Typography>
          )}
        </Grid>
        <Grid item md={3} xs={12}>
          {lab?.ports?.length > 0 && (
            <Typography variant="h4">Tabs: {lab.ports.length}</Typography>
          )}
        </Grid>
        <Grid item md={2} xs={12}>
          {/* Iconbutton to be disabled when not in draft mode */}
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            <PermissionsWrapper permissionGroup="admin">
              <IconButton onClick={handleRemoveLab}>
                <RemoveCircleIcon />
              </IconButton>
            </PermissionsWrapper>
          </Box>
        </Grid>
      </Grid>
    </PaperListRow>
  )
}

AddedLab.propTypes = {
  disabled: PropTypes.bool,
  lab: PropTypes.object,
  courseId: PropTypes.number,
}

export default AddedLab
